$( document ).ready(function() {  
  var maxHeight = 0;

  $(".team-list__row-list-item").each(function(){
    var thisH = $(this).height();
    if (thisH > maxHeight) { maxHeight = thisH; }
  });

  $(".team-list__row-list-item").height(maxHeight);
});